import React from "react";
import "./DiscardDraftModal.css";

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  discarding: boolean;
}

const DiscardDraftModal: React.FC<Props> = ({ onCancel, onConfirm, discarding }) => {
  React.useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !discarding) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel, discarding]);

  return (
    <div
      className="discard-draft-overlay"
      onClick={discarding ? undefined : onCancel}
    >
      <div className="discard-draft-modal" onClick={(e) => e.stopPropagation()}>
        <div className="discard-draft-title">Discard Draft</div>
        <p className="discard-draft-message">
          Discard this pull plan draft? Any staged changes it holds are removed
          and the draft is deleted.
        </p>
        <p className="discard-draft-warning">This action cannot be undone.</p>
        <div className="discard-draft-actions">
          <button
            type="button"
            className="discard-draft-cancel"
            onClick={onCancel}
            disabled={discarding}
          >
            Cancel
          </button>
          <button
            type="button"
            className="discard-draft-confirm"
            onClick={onConfirm}
            disabled={discarding}
          >
            {discarding ? "Discarding…" : "Discard Draft"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscardDraftModal;
